import React from "react";
import { Box, TablePagination } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid-pro";

interface ToolbarProps {
  page: number;
  pageSize: number;
  allCount: number;
  rowsPerPageOptions: number[];
  changePage: (pageIndex: number) => void;
  changePageSize: (pageSize: number) => void;
}

const CommercialMonitoringDataGridToolbar: React.FC<ToolbarProps> = (props) => {
  const {
    page,
    pageSize,
    allCount,
    rowsPerPageOptions,
    changePage,
    changePageSize,
  } = props;

  return (
    <GridToolbarContainer
      sx={{ p: 0, display: "flex", justifyContent: "space-between" }}
    >
      <Box sx={{ ml: "auto" }}>
        <TablePagination
          component="div"
          count={allCount}
          page={page}
          rowsPerPageOptions={rowsPerPageOptions}
          onPageChange={(_, newPage) => {
            changePage(newPage);
          }}
          rowsPerPage={pageSize}
          onRowsPerPageChange={(event) => {
            changePageSize(Number(event.target.value));
          }}
          labelRowsPerPage="ページあたりの行数:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from.toLocaleString()}〜${to.toLocaleString()} / ${count.toLocaleString()}`
          }
        />
      </Box>
    </GridToolbarContainer>
  );
};

export { CommercialMonitoringDataGridToolbar, type ToolbarProps };
